
import { CommonModule } from '@angular/common';
import { Component,  Input } from '@angular/core';
import { CapitalizeFirstPipe } from 'src/app/services/pipes/capitalizeFirst.pipe';

@Component({
    selector: 'traffic-light',
    template: `
<div class="light-holder">
  <div class="light" [ngClass]="color"></div>
  <div *ngIf="!!text" [ngClass]="{ dim: dim }"> {{ text | capitalizeFirst }}</div>
</div>
`,
    styleUrls: ['./traffic-light.scss'],
    standalone: true,
    imports: [CommonModule, CapitalizeFirstPipe],
})
export class TrafficLightComponent {
  @Input() color = "#dddddd"
  @Input() text = ""
  @Input() dim = false
}